import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useAlertLevelConfigs from '../../hooks/useAlertLevelConfig';

export const AlertLevels = ({ data, alertLevels, showColumnwise = false }) => {
  const { getLevelLabel, getLevelColor } = useAlertLevelConfigs(alertLevels);

  if (data) {
    return (
      <StyledContainer showColumnwise={showColumnwise}>
        <StyledDiv color={getLevelColor('High')}>
          {data?.High !== undefined
            ? getLevelLabel('High') + ': ' + data?.High?.toLocaleString('en-US')
            : ' -- '}
        </StyledDiv>
        <StyledDiv color={getLevelColor('Good')}>
          {data?.Good !== undefined
            ? getLevelLabel('Good') + ': ' + data?.Good?.toLocaleString('en-US')
            : ' -- '}
        </StyledDiv>
        <StyledDiv color={getLevelColor('Low')}>
          {data?.Low !== undefined
            ? getLevelLabel('Low') + ': ' + data?.Low?.toLocaleString('en-US')
            : ' -- '}
        </StyledDiv>
      </StyledContainer>
    );
  } else {
    return null;
  }
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.showColumnwise ? 'column' : 'row')};
  align-items: ${(props) => (props.showColumnwise ? 'flex-start' : 'center')};
  min-width: ${(props) => (props.showColumnwise ? '' : '145px')};
  gap: ${(props) => (props.showColumnwise ? '' : '12px')};
`;

const StyledDiv = styled.div`
  color: ${(props) => props.color};
`;

AlertLevels.propTypes = {
  data: PropTypes.object,
  alertLevels: PropTypes.array,
  showColumnwise: PropTypes.bool
};

const mapStateToProps = ({ amlsCommon }) => ({
  alertLevels: amlsCommon.alertLevelConfigs?.data
});

export default connect(mapStateToProps)(AlertLevels);
